function ready(fn) {
    if (document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading"){
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}


ready(() => {

    const el = document.getElementById('product-photo-switcher');
    const switcher = new ProductPhotoSwitcher(el);

});

class ProductPhotoSwitcher {

    constructor(el) {

        this.$el = el;
        this.$photo = el.querySelector('#product-photo');
        this.$name = el.querySelector('#product-size-name');
        this.$thumbnails = el.querySelectorAll('.thumbnail a');

        for (const a of this.$thumbnails) {
            let size = {
                'name': a.title,
                'url': a.href, // firstElementChild.src
            };
            a.addEventListener('click', this.switch.bind(this, a, size));
        }

        if (this.$thumbnails) {
            this.$thumbnails[0].className = 'selected';
        }

    }

    switch(el, size, ev) {
        ev.preventDefault();

        this.$photo.src = size.url;
        this.$name.innerHTML = size.name;

        for (const a of this.$thumbnails) {
            a.className = ''
        }

        // console.log(el);
        el.className = 'selected';

    }

}
